<div class="delegate-home-container" [ngClass]="'theme-'+userService.theme">
  <div class="routers">
    <div class="route-content" [routerLink]="['/coach/availability']">
        <app-inline-svg class="profiles-img" [file]="'assets/img/coach-calendar-main.svg'"></app-inline-svg>
      <div class="text">{{"__HOME_COACH_MY_AVAILABILITY__" | translate}}</div>
    </div>

    <div class="route-content" [routerLink]="['/coach/requests-incoming']">
      <div class="coaching-counter">
          <app-inline-svg class="profiles-img" [file]="'assets/img/icon-coach-appoint.svg'"></app-inline-svg>
        <div class="number primary-bg-color" *ngIf="progress !== null && progress.coach_requests.incompleted > 0">
          {{progress.coach_requests.incompleted}}
        </div>
      </div>

      <div class="text">{{"__HOME_COACH_REQUESTS__" | translate}}</div>
    </div>
  </div>
</div>
